"use strict";
// @ts-ignore
try {
    self['workbox:window:6.5.3'] && _();
}
catch (e) { }
